import { TrendingUp, Zap, Target, Shield, Plus, DollarSign } from 'lucide-react';

export const shortTurnModes = [
  {
    value: 'carry_over',
    label: 'Carry Over',
    description:
      'Your short-turn shift starts at the overtime rate your previous shift ended on. If the previous shift never reached overtime, it starts at the first overtime tier.',
    icon: TrendingUp,
    buttonLabel: 'Carry Over',
    technicalName: 'Carry Over'
  },
  {
    value: 'bump_up',
    label: 'Bump Up',
    description:
      'Your short-turn shift starts one tier above where your previous shift ended.',
    icon: Zap,
    buttonLabel: 'Bump Up',
    technicalName: 'Bump Up'
  },
  {
    value: 'offset_overtime',
    label: 'Offset Overtime',
    description:
      'Every hour of your short-turn shift is shifted up by a fixed number of overtime tiers on top of whichever rate you would otherwise be earning.',
    icon: Target,
    buttonLabel: 'Offset Overtime',
    technicalName: 'Offset Overtime'
  },
  {
    value: 'guaranteed_rate',
    label: 'Guaranteed Rate',
    description: 'Your pay is brought up to a chosen rate tier for short-turn hours. If you already earn that rate or higher from overtime, no additional surcharge is added.',
    icon: Shield,
    buttonLabel: 'Guaranteed Rate',
    technicalName: 'Guaranteed Rate'
  },
  {
    value: 'hourly_premium',
    label: 'Hourly Premium',
    description: 'Adds a per-hour premium on top of your base rate for the duration of the short-turn shift.',
    icon: Plus
  },
  {
    value: 'fixed_dollar',
    label: 'Fixed Premium',
    description:
      'Adds a flat dollar amount to the shift total, regardless of hours worked or rate.',
    icon: DollarSign,
    technicalName: 'Fixed Premium'
  }
];
